import React from 'react';
import { FC } from 'react';

export const Lists: FC = () => {
    return (
        <div>
            <div> 
                <iframe title="Slide" src="https://docs.google.com/presentation/d/e/2PACX-1vT13ijim3KhfIDVufHDzXOaGBbxYImv8-j_4WQSWSNpgzzryJPE-ljuUXFXYX8wsdNCVkmCbOMs5Qs0/embed?start=false&loop=false&delayms=60000"
                 width="1200" height="675">
        
                 </iframe>
            </div>
            <form>
                <label>Notes</label>
                <textarea>
                </textarea>
            </form>
        </div>
    )
};